// proto/v2/audio/audio.proto
//
// Audio Overview — multi-speaker podcast generation (AUDIO-01).
// See docs/plans/2026-06-22-audio-overview-design.md.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file audio/audio.proto (package lvdr.v2.audio, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file audio/audio.proto.
 */
export const file_audio_audio: GenFile = /*@__PURE__*/
  fileDesc("ChFhdWRpby9hdWRpby5wcm90bxINbHZkci52Mi5hdWRpbyK7AgoMQXVkaW9FcGlzb2RlEhIKCmVwaXNvZGVfaWQYASABKAkSEAoIb3duZXJfaWQYAiABKAkSEgoKc2Vzc2lvbl9pZBgDIAEoCRINCgV0aXRsZRgEIAEoCRIOCgZzdGF0dXMYBSABKAkSDQoFZXJyb3IYBiABKAkSFAoMc291cmNlX2xhYmVsGAcgASgJEhUKDXNwZWFrZXJfY291bnQYCCABKAUSFgoOc3BlYWtlcl9sYWJlbHMYCSADKAkSFQoNZHVyYXRpb25fc2VjcxgKIAEoARISCgpzaXplX2J5dGVzGAsgASgDEg8KB2NyZWRpdHMYDCABKAMSEgoKdHJhbnNjcmlwdBgNIAEoCRIuCgpjcmVhdGVkX2F0GA4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIvChlMaXN0QXVkaW9PdmVydmlld3NSZXF1ZXN0EhIKCnNlc3Npb25faWQYASABKAkiSwoaTGlzdEF1ZGlvT3ZlcnZpZXdzUmVzcG9uc2USLQoIZXBpc29kZXMYASADKAsyGy5sdmRyLnYyLmF1ZGlvLkF1ZGlvRXBpc29kZSItChdHZXRBdWRpb092ZXJ2aWV3UmVxdWVzdBISCgplcGlzb2RlX2lkGAEgASgJIkgKGEdldEF1ZGlvT3ZlcnZpZXdSZXNwb25zZRIsCgdlcGlzb2RlGAEgASgLMhsubHZkci52Mi5hdWRpby5BdWRpb0VwaXNvZGUiMAoaRGVsZXRlQXVkaW9PdmVydmlld1JlcXVlc3QSEgoKZXBpc29kZV9pZBgBIAEoCSJCChtEZWxldGVBdWRpb092ZXJ2aWV3UmVzcG9uc2USEgoKZXBpc29kZV9pZBgBIAEoCRIPCgdkZWxldGVkGAIgASgIIkEKEUF1ZGlvRXBpc29kZUV2ZW50EiwKB2VwaXNvZGUYASABKAsyGy5sdmRyLnYyLmF1ZGlvLkF1ZGlvRXBpc29kZUImWiRnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvYXVkaW9iBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * AudioEpisode mirrors internal/audiooverview.Episode on the wire. The audio
 * bytes themselves are NOT carried here — they are fetched per-user-encrypted
 * via GET /api/v1/audio-overviews/:id/audio. This message is metadata only.
 *
 * @generated from message lvdr.v2.audio.AudioEpisode
 */
export type AudioEpisode = Message<"lvdr.v2.audio.AudioEpisode"> & {
  /**
   * @generated from field: string episode_id = 1;
   */
  episodeId: string;

  /**
   * @generated from field: string owner_id = 2;
   */
  ownerId: string;

  /**
   * originating chat session
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * "generating" | "ready" | "failed"
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * populated when status == "failed" (e.g. "session_locked")
   *
   * @generated from field: string error = 6;
   */
  error: string;

  /**
   * human-readable source ("Research: …", "Conversation", …)
   *
   * @generated from field: string source_label = 7;
   */
  sourceLabel: string;

  /**
   * @generated from field: int32 speaker_count = 8;
   */
  speakerCount: number;

  /**
   * @generated from field: repeated string speaker_labels = 9;
   */
  speakerLabels: string[];

  /**
   * @generated from field: double duration_secs = 10;
   */
  durationSecs: number;

  /**
   * @generated from field: int64 size_bytes = 11;
   */
  sizeBytes: bigint;

  /**
   * actual credits charged (0 until settled)
   *
   * @generated from field: int64 credits = 12;
   */
  credits: bigint;

  /**
   * the spoken script, for the transcript toggle
   *
   * @generated from field: string transcript = 13;
   */
  transcript: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.audio.AudioEpisode.
 * Use `create(AudioEpisodeSchema)` to create a new message.
 */
export const AudioEpisodeSchema: GenMessage<AudioEpisode> = /*@__PURE__*/
  messageDesc(file_audio_audio, 0);

/**
 * @generated from message lvdr.v2.audio.ListAudioOverviewsRequest
 */
export type ListAudioOverviewsRequest = Message<"lvdr.v2.audio.ListAudioOverviewsRequest"> & {
  /**
   * empty — scoped to the authenticated user
   *
   * optional: filter to one chat session
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.audio.ListAudioOverviewsRequest.
 * Use `create(ListAudioOverviewsRequestSchema)` to create a new message.
 */
export const ListAudioOverviewsRequestSchema: GenMessage<ListAudioOverviewsRequest> = /*@__PURE__*/
  messageDesc(file_audio_audio, 1);

/**
 * @generated from message lvdr.v2.audio.ListAudioOverviewsResponse
 */
export type ListAudioOverviewsResponse = Message<"lvdr.v2.audio.ListAudioOverviewsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.audio.AudioEpisode episodes = 1;
   */
  episodes: AudioEpisode[];
};

/**
 * Describes the message lvdr.v2.audio.ListAudioOverviewsResponse.
 * Use `create(ListAudioOverviewsResponseSchema)` to create a new message.
 */
export const ListAudioOverviewsResponseSchema: GenMessage<ListAudioOverviewsResponse> = /*@__PURE__*/
  messageDesc(file_audio_audio, 2);

/**
 * @generated from message lvdr.v2.audio.GetAudioOverviewRequest
 */
export type GetAudioOverviewRequest = Message<"lvdr.v2.audio.GetAudioOverviewRequest"> & {
  /**
   * @generated from field: string episode_id = 1;
   */
  episodeId: string;
};

/**
 * Describes the message lvdr.v2.audio.GetAudioOverviewRequest.
 * Use `create(GetAudioOverviewRequestSchema)` to create a new message.
 */
export const GetAudioOverviewRequestSchema: GenMessage<GetAudioOverviewRequest> = /*@__PURE__*/
  messageDesc(file_audio_audio, 3);

/**
 * @generated from message lvdr.v2.audio.GetAudioOverviewResponse
 */
export type GetAudioOverviewResponse = Message<"lvdr.v2.audio.GetAudioOverviewResponse"> & {
  /**
   * @generated from field: lvdr.v2.audio.AudioEpisode episode = 1;
   */
  episode?: AudioEpisode | undefined;
};

/**
 * Describes the message lvdr.v2.audio.GetAudioOverviewResponse.
 * Use `create(GetAudioOverviewResponseSchema)` to create a new message.
 */
export const GetAudioOverviewResponseSchema: GenMessage<GetAudioOverviewResponse> = /*@__PURE__*/
  messageDesc(file_audio_audio, 4);

/**
 * @generated from message lvdr.v2.audio.DeleteAudioOverviewRequest
 */
export type DeleteAudioOverviewRequest = Message<"lvdr.v2.audio.DeleteAudioOverviewRequest"> & {
  /**
   * @generated from field: string episode_id = 1;
   */
  episodeId: string;
};

/**
 * Describes the message lvdr.v2.audio.DeleteAudioOverviewRequest.
 * Use `create(DeleteAudioOverviewRequestSchema)` to create a new message.
 */
export const DeleteAudioOverviewRequestSchema: GenMessage<DeleteAudioOverviewRequest> = /*@__PURE__*/
  messageDesc(file_audio_audio, 5);

/**
 * @generated from message lvdr.v2.audio.DeleteAudioOverviewResponse
 */
export type DeleteAudioOverviewResponse = Message<"lvdr.v2.audio.DeleteAudioOverviewResponse"> & {
  /**
   * @generated from field: string episode_id = 1;
   */
  episodeId: string;

  /**
   * @generated from field: bool deleted = 2;
   */
  deleted: boolean;
};

/**
 * Describes the message lvdr.v2.audio.DeleteAudioOverviewResponse.
 * Use `create(DeleteAudioOverviewResponseSchema)` to create a new message.
 */
export const DeleteAudioOverviewResponseSchema: GenMessage<DeleteAudioOverviewResponse> = /*@__PURE__*/
  messageDesc(file_audio_audio, 6);

/**
 * AudioEpisodeEvent is the async push when generation finishes (ready/failed)
 * or progresses. It is the fallback delivery path when the originating chat
 * session is gone (see design SF1).
 *
 * @generated from message lvdr.v2.audio.AudioEpisodeEvent
 */
export type AudioEpisodeEvent = Message<"lvdr.v2.audio.AudioEpisodeEvent"> & {
  /**
   * @generated from field: lvdr.v2.audio.AudioEpisode episode = 1;
   */
  episode?: AudioEpisode | undefined;
};

/**
 * Describes the message lvdr.v2.audio.AudioEpisodeEvent.
 * Use `create(AudioEpisodeEventSchema)` to create a new message.
 */
export const AudioEpisodeEventSchema: GenMessage<AudioEpisodeEvent> = /*@__PURE__*/
  messageDesc(file_audio_audio, 7);

